var PROJ = (typeof PROJ === 'object') ? PROJ : {};
var countdownInterval;
PROJ.ajaxcart = {
    VAR: {},
    _subGiftSyncInFlight: false,
    _subGiftSyncPromise: null,

    cartUrl: function (path) {
        var root = (window.theme && window.theme.localeRootUrl) || '';
        return root + path;
    },

    getSubGiftConfig: function () {
        var el = document.getElementById('sub-gift-config');
        if (!el) return null;
        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            return null;
        }
    },

    getPlanGiftConfig: function () {
        var el = document.getElementById('plan-gift-config');
        if (!el) return null;
        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            return null;
        }
    },

    getSkipGiftVariantIds: function () {
        var el = document.querySelector('#mini-cart [data-skip-gift-variant-ids]');
        if (!el) return [];
        return String(el.getAttribute('data-skip-gift-variant-ids') || '')
            .split(',')
            .map(function (id) {
                return parseInt(id.trim(), 10);
            })
            .filter(function (id) {
                return !isNaN(id);
            });
    },

    shouldSkipGiftConfig: function (cfg) {
        if (!cfg || !cfg.variantId) return true;
        var skipIds = this.getSkipGiftVariantIds();
        if (!skipIds.length) return false;
        return skipIds.indexOf(parseInt(cfg.variantId, 10)) !== -1;
    },

    getCartGiftConfigs: function () {
        var byVariant = {};
        var sources = [this.getSubGiftConfig(), this.getPlanGiftConfig()];

        sources.forEach(function (cfg) {
            if (!cfg || !cfg.variantId || this.shouldSkipGiftConfig(cfg)) return;
            var id = String(cfg.variantId);
            if (!byVariant[id]) {
                byVariant[id] = {
                    variantId: cfg.variantId,
                    enabled: cfg.enabled !== false,
                    allSubsQualify: !!cfg.allSubsQualify,
                    qualifyTerms: (cfg.qualifyTerms || []).slice()
                };
                return;
            }
            if (cfg.enabled !== false) byVariant[id].enabled = true;
            if (cfg.allSubsQualify) byVariant[id].allSubsQualify = true;
            (cfg.qualifyTerms || []).forEach(function (term) {
                if (byVariant[id].qualifyTerms.indexOf(term) === -1) {
                    byVariant[id].qualifyTerms.push(term);
                }
            });
        }, this);

        return Object.keys(byVariant).map(function (key) {
            return byVariant[key];
        });
    },

    lineQualifyText: function (line) {
        var vt = line.variant_title ? String(line.variant_title).toLowerCase() : '';
        if (vt === 'default title') {
            vt = line.product_title ? String(line.product_title).toLowerCase() : '';
        }
        var spn =
            line.selling_plan_allocation &&
            line.selling_plan_allocation.selling_plan &&
            line.selling_plan_allocation.selling_plan.name
                ? String(line.selling_plan_allocation.selling_plan.name).toLowerCase()
                : '';
        return (vt + ' ' + spn).trim();
    },

    cartQualifiesForSubGift: function (cart, cfg) {
        if (!cart || !cart.items || !cart.items.length) return false;
        var terms = (cfg.qualifyTerms || [])
            .map(function (t) {
                return String(t).trim();
            })
            .filter(function (t) {
                return t;
            });
        if (cfg.allSubsQualify || !terms.length) {
            for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].selling_plan_allocation) return true;
            }
            return false;
        }
        for (var j = 0; j < cart.items.length; j++) {
            var line = cart.items[j];
            if (!line.selling_plan_allocation) continue;
            var text = this.lineQualifyText(line);
            for (var k = 0; k < terms.length; k++) {
                var term = terms[k].toLowerCase();
                if (text.indexOf(term) !== -1) return true;
            }
        }
        return false;
    },

    getSubGiftVariantQty: function (cart, variantId) {
        var id = parseInt(variantId, 10);
        if (!cart || !cart.items) return 0;
        for (var i = 0; i < cart.items.length; i++) {
            if (parseInt(cart.items[i].variant_id, 10) === id) {
                return cart.items[i].quantity;
            }
        }
        return 0;
    },

    syncSubscriptionGift: function () {
        var _this = this;
        var configs = _this.getCartGiftConfigs();
        if (!configs.length) {
            return Promise.resolve();
        }
        if (_this._subGiftSyncInFlight && _this._subGiftSyncPromise) {
            return _this._subGiftSyncPromise;
        }

        _this._subGiftSyncInFlight = true;
        _this._subGiftSyncPromise = fetch(_this.cartUrl('/cart.js'), { credentials: 'same-origin' })
            .then(function (res) {
                return res.json();
            })
            .then(function (cart) {
                var updates = {};

                configs.forEach(function (cfg) {
                    var giftQty = _this.getSubGiftVariantQty(cart, cfg.variantId);

                    if (cfg.enabled === false) {
                        if (giftQty > 0) updates[cfg.variantId] = 0;
                        return;
                    }

                    var qualifies = _this.cartQualifiesForSubGift(cart, cfg);
                    if (qualifies && giftQty === 0) {
                        updates[cfg.variantId] = 1;
                    } else if (!qualifies && giftQty > 0) {
                        updates[cfg.variantId] = 0;
                    }
                });

                if (!Object.keys(updates).length) return null;

                return fetch(_this.cartUrl('/cart/update.js'), {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ updates: updates })
                });
            })
            .catch(function () {})
            .finally(function () {
                _this._subGiftSyncInFlight = false;
                _this._subGiftSyncPromise = null;
            });

        return _this._subGiftSyncPromise;
    },

    init: function () {
        var _this = this;

        setTimeout(function(){
            _this.reloadOfferbar();
            _this.animateCart();
        },100);

        $('body').on('click', '.plus-minus .minus', function (e) {
            e.preventDefault();
            var box = $(this).parent().find('input');
            if(parseInt(box.val()) >0) box.val(parseInt(box.val())-1);
            box.trigger('change');
        });
        $('body').on('click', '.plus-minus .plus', function (e) {
            e.preventDefault();
            var box = $(this).parent().find('input');
            box.val(parseInt(box.val())+1);
            box.trigger('change');
        });


        if (window.location.href.indexOf("minicart=true") > -1) {
            $('body,html').addClass('mini-cart');
            setTimeout(function(){
                $('body,html').addClass('mini-cart-ani');
            },500);
        }

        $('body').on('click', '.nav-close-cart, .minicart-back', function (e) {
            e.preventDefault();
            _this.closecart();
        });

        $('body').on('click tap', 'a.mini_cart, .opencart,[href="/cart"] ,.header-cart__icon, [data-drawer-new]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation()
            // e.stopImmediatePropagation();
            $('body').removeClass('activeupsell');
            _this.opencart();
        });

        $('body').on('click', '[data-varid]', function (e) {
            e.preventDefault();
            var varid = $(this).attr('data-varid');
            $(this).parents('.cross-slide').find('[data-directadd]').attr('data-directadd',varid);
            $(this).parents('.cross-slide').find('.moneys').html($(this).attr('data-varprice') );
            $(this).parents('.cross-slide').find('[data-varid]').removeClass('active');
            $(this).addClass('active');
        });

        $('body').on('change', '.mcart-item [data-proid].qty-input', function (e) {
            e.preventDefault();
            var ids = $(this).attr('data-proid');
            var qty = $(this).val();
            _this.updateItem(ids, qty);
            setTimeout(function(){
                if($('body').hasClass('template-cart'))
                {
                    location.reload(true);
                }
            },500);
        });

        $('body').on('click', '[data-directadd]', function (e) {
            e.preventDefault();
            _this.addItem($(this).attr('data-directadd'));
        });

        //shipping protection
        $('body').on('click', '[data-protection-id]', function (e) {
            e.preventDefault();
            if($(this).hasClass('active'))
            {
                sessionStorage.clear('yesprotection');
                _this.updateItem($(this).attr('data-protection-id'), 0);
            }else
            {
                sessionStorage.setItem('yesprotection',true);
                _this.addItem($(this).attr('data-protection-id'));
            }
        });


        //remove from mini cart
        $('body').on('click', '.incart .remove', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = 0;
            _this.updateItem(par.attr('data-proid'), qty);
        });

        $('body').on('click','[data-upgrade-item]',function(e){
            e.preventDefault();
            var varids = $(this).attr('data-upgrade-item').split(',');

            $.post('/cart/update.js', {
                'updates': {
                    [varids[0]]: 0, [varids[1]]: 1
                }
            })
                .done(function(cart) {
                    _this.updateCart();
                })
                .fail(function(xhr, status, error) {
                    _this.updateCart();
                });
        });

        var cform;

        // AJAX-only add-to-cart: avoid form submit so Shopify customer events
        // do not log product_added_to_cart twice (submit + /cart/add.js).
        function addToCartViaAjax($addToCartForm) {
            cform = $addToCartForm;
            var $addToCartBtn = $('.cart-btn button');
            $('#mini-cart').addClass('loading');

            $addToCartBtn.addClass('disabled').prop('disabled', true);

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function (itemData) {
                    var cuid = $('[data-upsell-var="'+itemData.id+'"]');

                    if (cuid.length) {
                        callUpsell(cuid);
                    } else {
                        _this.updateCart();
                        $addToCartBtn.removeClass('disabled').prop('disabled', false);
                        $('body').removeClass('hidetop');
                        _this.opencart();
                    }
                },
                error: function () {
                    _this.updateCart();
                    $addToCartBtn.removeClass('disabled').prop('disabled', false);
                }
            });
        }

        function shouldHandleMiniCartAdd($form) {
            if (typeof newMiniCart === 'undefined' || !newMiniCart) return false;
            if (!$form || !$form.length) return false;
            // Popup ATC is owned by js-25-card.js
            if ($form.closest('.pc25-popup-overlay').length) return false;
            return true;
        }

        $('body').on('click', 'form[action="/cart/add"] [type="submit"]', function (e) {
            var $form = $(this).closest('form[action="/cart/add"]');
            if (!shouldHandleMiniCartAdd($form)) return;
            e.preventDefault();
            addToCartViaAjax($form);
        });

        // Enter in form fields would still submit — route through AJAX only
        $('body').on('keydown', 'form[action="/cart/add"] input, form[action="/cart/add"] select', function (e) {
            if (e.key !== 'Enter' && e.keyCode !== 13) return;
            var $form = $(this).closest('form[action="/cart/add"]');
            if (!shouldHandleMiniCartAdd($form)) return;
            e.preventDefault();
            addToCartViaAjax($form);
        });

        // Safety net: block native submit navigation if anything still submits
        $('body').on('submit', 'form[action="/cart/add"]', function (e) {
            if (!shouldHandleMiniCartAdd($(this))) return;
            e.preventDefault();
            return false;
        });

        $('body').on('click','.close-cart-note', function (e) {
            e.preventDefault();
            $('.cart-note-wrap').toggleClass('cartnote');
        });

        $('body').on('click','.cart-note-btn', function (e) {
            var dataToSend = "note="+encodeURIComponent($('#cart-note').val());
            $('.cart-note-wrap').removeClass('cartnote');
            $.ajax({
                type: "POST",
                url: "/cart/update.js",
                // data: "{note="+ +"}",
                data: dataToSend ,
                dataType: "json",
                success: function(e) {
                },
                error: function(e, t) {
                },
                complete: function() {
                }
            });
        });

        _this.scrollbarmob();

    },
    scrollbarmob: function () {
        // mobile slider
        $('.slider-bar-trigger:not(.active)').each(function(){
            var pr = $(this).parents('.slider-wrap-parent');
            var sli = pr.find('.mobile-bar');
            if(pr.find('.slider-bar-trigger').get(0).scrollWidth - pr.width() <= 0)
            {
                pr.find('.mobile-bar-cover').remove();
                $(this).addClass('active');
            }
        });

        $('.slider-bar-trigger:not(.active)').on('scroll',function(e){
            e.preventDefault();
            var pr = $(this).parents('.slider-wrap-parent');
            var sli = pr.find('.mobile-bar');
            var mat = $(this).attr('data-match')?parseInt($(this).attr('data-match')):0;
            sli.find('.sli').css('left',(sli.width()-sli.find('.sli').width()) * ($(this).scrollLeft()/(pr.find('.slider-bar-trigger').get(0).scrollWidth - pr.width() - mat )) );
            // sli.find('.sli').css('left', (-100+(92*($(this).scrollLeft()/(pr.find('.slider-bar-trigger').get(0).scrollWidth - pr.width() ))))+'%' );
        });

        $('.slider-bar-trigger').addClass('active');

        if($('.cross-scroll').length) deskmouscroll(document.querySelector('.cross-scroll'));
    },
    updateCart: function () {
        var _this = this;
        $('body,html').removeClass('mini-cart-ani');
        _this.syncSubscriptionGift().then(function () {
            $.get("/cart?view=mini", function (data) {

                $('#mini-cart .ajax_place').html($(data));

                var counti = $('[data-icount]').attr('data-icount');
                $('.header__cart-icon-count').text(counti);
                counti==0? $('.header__cart-icon-dot').removeClass('is-visible'): $('.header__cart-icon-dot').addClass('is-visible');
                _this.reloadOfferbar();

            }).done(function (cart) {
                _this.animateCart();
                $('#mini-cart').removeClass('loading');
                $('body,html').addClass('mini-cart-ani');
            });
        });
    }, animateCart: function () {
        // to update and animate mini cart with total price
        var _this = this;

        $('.ns-target-gift').appendTo('.target-gifts');

        var locks = $('.target-locks .target');
        var rate = typeof market_exchange_rate !== 'undefined'? market_exchange_rate : 1;
        // rate = 1;
        var progess_bar_val = $('.ns-progress').data('progress'); // total price

        var gifts = $('.ns-target-gift');
        for (var i = 0; i < gifts.length; i++) {
            var target = gifts.eq(i);
            //blackfriday
            if(progess_bar_val >= (target.attr('data-gift-target')*rate) && target.hasClass('noproduct')) {
                target.addClass('gifttrue');
                target.find('.cafter').show();
            }else
            {
                target.find('.cbefore').show();
            }

            if(progess_bar_val >= (target.attr('data-gift-target')*rate) && target.hasClass('giftfalse') && target.hasClass('noappgift'))
            {
                if(!target.hasClass('noautoadd'))
                {
                    _this.addItem(target.attr('data-gift-id'));
                    return;
                }
            }else if (progess_bar_val < (target.attr('data-gift-target')*rate) && target.hasClass('gifttrue') && target.hasClass('noappgift'))
            {
                _this.updateItem(target.attr('data-gift-id'),0);
                return;
            }else if (target.hasClass('multigift'))
            {
                _this.updateItem(target.attr('data-gift-id'),1);
                return;
            }

        }

        var gap = 100 / (locks.length - 1);
        var current_target;
        var next_target;
        var last_target = locks.eq(locks.length - 1);
        locks.each(function(i){
            if(progess_bar_val >= ($(this).data('target')*rate))
            {
                var element = $(this);
                current_target = $(this);
                next_target = locks.eq(i+1);
                setTimeout(function() {
                    element.addClass("active");
                }, 300 * i);
            }
        });

        if(locks.length <= 2) $('.mini-cart .top-wrap').hide();

        if(next_target) {
            if (next_target.length) {
                var extraval = (progess_bar_val - (current_target.data('target')*rate)) / ((next_target.data('target') - current_target.data('target'))*rate);
                var barwidth = (current_target.index() * gap) + (gap * extraval);
                $('.ns-progress-fill').width(barwidth + "%");
            } else {
                $('.ns-progress-fill').width("100%");
            }
        }

         // _this.callBFCM(); activate this for special countdown cross sells

    },

    //blackfriday
    callBFCM:function () {
        var _this = this;
        const countdownDuration = 30 * 60 * 1000;
        var ls = 'count6';
        var num = 'num6';
        var rannum = Math.ceil(parseInt($('[data-set]:last-child').attr('data-set'))*Math.random());
        var total = parseInt($('[data-set]:last-child').attr('data-set'));
        if(rannum == total) rannum = total-1;


        var set = localStorage.getItem(num);
        if (!set || set == "NaN") {
            set = rannum;
            localStorage.setItem(num, set);
        }

        if(set > total)
        {
            set = 1;
            localStorage.setItem(num, set);
        }
        // console.log(set);
        console.log(set,total);

        let endTime = localStorage.getItem(ls);

        // If no end time is saved, set a new end time
        if (!endTime) {
            endTime = Date.now() + countdownDuration;
            localStorage.setItem(ls, endTime);
        }

        $('[data-set]').hide();
        $('[data-set="'+set+'"]').show();
        $('[data-set="0"]').show();


        // Update the countdown display every second
        clearInterval(countdownInterval);
        $('#countdown').show();
        gotime();
         countdownInterval = setInterval(function() {
             gotime();
        }, 1000);

         function gotime()
         {
             var timeLeft = endTime - Date.now();

             // Calculate minutes and seconds
             var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
             var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
             if(minutes < 0) minutes = 0;
             if(seconds < 0) seconds = 0;
             var sec = seconds<10?"0"+seconds:seconds;
             var min = minutes<10?"0"+minutes:minutes;

             // Display the countdown
             $('#countdown .min').text(`${min}`);
             $('#countdown .sec').text(`${sec}`);

             // If the countdown is over, clear the interval and remove end time from local storage
             if (timeLeft <= 2) {
                 clearInterval(countdownInterval);
                 localStorage.removeItem(ls);
                 _this.updateCart();
                 set = parseInt(set)+1;
                 if(set > total) set = 1;
                 localStorage.setItem(num, set);
             }
         }

    },  reloadOfferbar:function () {
        var rate = typeof market_exchange_rate !== 'undefined'? market_exchange_rate : 1;
        $('[data-target]').each(function () {
            var val = $(this).attr('data-target');
            if($(this).find('sp').length)
            {
                $(this).find('sp').text(Math.round(val*rate / 100));
            }

        });
    },

    addItem: function (id) {
        var _this = this;

        if(!$('body').hasClass('upsell-cart'))
        {
            $('#mini-cart').addClass('loading');
            $('body,html').addClass('mini-cart');
        }

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + id,
            dataType: "json",
            success: function (t) {
                if(!$('body').hasClass('upsell-cart'))
                {
                    _this.updateCart();
                }else
                {
                    PROJ.upsells.opencart();
                    PROJ.upsells.closequickbuy();
                    _this.updateCart();
                }

            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },

    updateItem: function (id, le) {
        var _this = this;
        $('#mini-cart').addClass('loading');


        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + le + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
                if($('body').hasClass('upsell-cart'))
                {
                    PROJ.upsells.opencart();
                }
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },


    opencart: function () {

        $('body,html').addClass('mini-cart');
        setTimeout(function(){
            $('body,html').addClass('mini-cart-ani');
        },500);
    },
    closecart: function () {
        $('body,html').removeClass('mini-cart');
        setTimeout(function(){
            $('body,html').removeClass('mini-cart-ani');
        },500);
    }


};
jQuery(document).ready(function() {

    if(newMiniCart)PROJ.ajaxcart.init();
});

function deskmouscroll(element)
{

    const ele = element;
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function(e) {
        ele.style.cursor = 'grabbing';
        ele.style.userSelect = 'none';

        pos = {
            left: ele.scrollLeft,
            x: e.clientX,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = function(e) {
        const dx = e.clientX - pos.x;
        ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function() {
        ele.style.cursor = 'grab';
        ele.style.removeProperty('user-select');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    };

    // Attach the handler
    ele.addEventListener('mousedown', mouseDownHandler);
}


document.addEventListener("click", function (event) {
    //ac hides
    if (event.target.classList.contains("ac-com")) {
        event.target.classList.toggle("active");

        let nextElement = event.target.nextElementSibling;
        while (nextElement && !nextElement.classList.contains("ac-com")) {
            nextElement.classList.toggle("active");
            nextElement = nextElement.nextElementSibling;
        }
    }
    if (event.target.classList.contains("swappop")) {
        event.preventDefault();
        document.body.classList.toggle("popup-cartcard");

        const target = document.querySelector('.mc-popproduct-wrap');
        if (target) document.querySelector('.c-scroll-section').scrollTo({ top: target.offsetTop - 50, behavior: 'smooth' });
    }
});



//product common card actions to go all pages (collection / featured)

document.addEventListener('change', function(event) {
    if (event.target.matches('.jspc-onetime select')) {
        const selectElement = event.target;
        const selectedIndex = selectElement.selectedIndex; // Get the option's position (0-based)

        // Find the closest parent `.js-card`
        const parentCard = selectElement.closest('.js-card');
        if (parentCard) {
            const priceElement = parentCard.querySelector('.onetime-price');
            if (priceElement) {
                priceElement.setAttribute('data-shows', selectedIndex);
            }
        }
    }

    if (event.target.matches('.jspc-subscribe select')) {
        const selectElement = event.target;
        const selectedIndex = selectElement.selectedIndex; // Get the option's position (0-based)

        // Find the closest parent `.js-card`
        const parentCard = selectElement.closest('.js-card');
        if (parentCard) {
            const priceElement = parentCard.querySelector('.subs-price');
            if (priceElement) {
                priceElement.setAttribute('data-shows', selectedIndex);
            }
        }
    }
});
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('jspc-add')) {
        event.preventDefault();
        const parentWrap = event.target.closest('.jspc-add-wrap'); // Find closest parent
        if (parentWrap) {
            const selectElement = parentWrap.querySelector('select'); // Find the select inside parent
            if (selectElement) {
                const selectedValue = selectElement.value; // Get selected value

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: selectedValue
                })
                    .then(res => res.json()).then(data => {
                    PROJ.ajaxcart.updateCart();
                    PROJ.ajaxcart.opencart();
                })
                    .catch(err => console.error('Error:', err));

            }
        }
    }
    const sprotectEl = event.target.closest('[data-sprotect-add]');
    if (event.target.closest('.warning-check')) {
        event.preventDefault();
        document.querySelector('.mc-warning')?.classList.add('active');

        if (sprotectEl) {
            const varid = sprotectEl.getAttribute('data-sprotect-add');
            if (varid) {
                const mcWarningCheckout = document.querySelector('.mc-warning-checkout');
                if (mcWarningCheckout) {
                    mcWarningCheckout.setAttribute('data-sprotect-add', varid);
                }
    }
        }

    }else if (sprotectEl) {
        event.preventDefault();

        const varid = sprotectEl.getAttribute('data-sprotect-add');
        if (varid) {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    updates: {
                        [varid]: 1
                    }
                })
            })
            .then(() => {
                window.location.href = '/checkout';
            })
            .catch(() => {
                window.location.href = '/checkout';
            });
        }

    }

    if (event.target.closest('.mc-warning-close')) {
        event.preventDefault();
        document.querySelector('.mc-warning')?.classList.remove('active');
    }

if (event.target.closest('.mc-sp-pr')) {
    document.querySelectorAll('.prot_extra').forEach(function(el) {
        el.classList.toggle('active');
    });
}

    const btn = event.target.closest('[data-turn-sub]');
    if (btn)
    {
        event.preventDefault();
        (async () => {
            btn.disabled = true;
            btn.textContent = 'Switching...';

            const select = btn.closest('.special-savings-card').querySelector('select');
            const [removeId, addId, sellingPlan] = select.value.split(',');

            try {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: { [removeId]: 0 } })
                });

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [
                            { id: +addId, quantity: 1, selling_plan: +sellingPlan }
                        ]
                    })
                });

                if (window.PROJ?.ajaxcart?.updateCart) {
                    PROJ.ajaxcart.updateCart();
                } else {
                    window.location.reload();
                }

            } catch (err) {
                console.error('Switch to subscription failed:', err);
                alert('Something went wrong, please try again.');
            } finally {
                btn.disabled = false;
                btn.textContent = 'Switch to Subscription';
            }
        })();
    }

    const swapsBtn = event.target.closest('.sub-swaps');
    if (swapsBtn) {
        const mcSubProm = swapsBtn.closest('.mc-sub-prom');
        if (mcSubProm) {
            mcSubProm.classList.toggle('active');
        }
    }


});


//add automatic subscription activation
location.search.includes('subactive') && document.body.classList.add('subactive');

// Warning popup functionality
document.addEventListener('click', function(e) {
    const warningEl = e.target.closest('.jspc-warning');
    if (warningEl) {
        e.preventDefault();
        const detailsEl = warningEl.querySelector('.jspc-warning-details');
        if (detailsEl) {
            const detailsContent = detailsEl.innerHTML;

            // Create overlay
            const overlay = document.createElement('div');
            overlay.className = 'jspc-warning-overlay';

            // Create popup
            const popup = document.createElement('div');
            popup.className = 'jspc-warning-popup';

            // Create close button
            const closeBtn = document.createElement('button');
            closeBtn.className = 'jspc-warning-close-btn';
            closeBtn.innerHTML = '×';
            closeBtn.setAttribute('aria-label', 'Close');

            // Create content div
            const contentDiv = document.createElement('div');
            contentDiv.className = 'jspc-warning-popup-content';
            contentDiv.innerHTML = detailsContent;

            // Assemble popup
            popup.appendChild(closeBtn);
            popup.appendChild(contentDiv);
            overlay.appendChild(popup);

            // Add to body
            document.body.appendChild(overlay);

            // Prevent body scroll
            document.body.style.overflow = 'hidden';

            // Close handlers
            const closePopup = function() {
                overlay.remove();
                document.body.style.overflow = '';
            };

            closeBtn.addEventListener('click', closePopup);
            overlay.addEventListener('click', function(e) {
                if (e.target === overlay) {
                    closePopup();
                }
            });
        }
    }
});


